import React, { useCallback, useState } from 'react'
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import cx from 'classnames';

import TableAction from '../../CommonTable/TableAction';
import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination/CustomPagination';

import { deletePromoCodeData, updatePromoCodeStatus } from '../../../actions/siteadmin/PromoCode/managePromoCodeData';
import history from '../../../core/history';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomConfirmModal from '../../Common/CustomConfirmModal/CustomConfirmModal';
import { getPromoCodeValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from '../../../components/commonStyle.css';
import messages from '../../../locale/jsonMessages';


const ManagePromoCodeSection = (props) => {
    const {
        title,
        loading,
        getAllPromoCode,
        refetch,
        currentPage,
        setStateVariable
    } = props;
    const intl = useIntl();
    const dispatch = useDispatch();
    const [modalState, setModalState] = useState(false);
    const [selectedId, setSelectedId] = useState(null);


    const paginationData = (newPage) => {
        const variables = { currentPage: newPage };
        setStateVariable(variables);
        refetch(variables);
    };

    const handleSearchChange = (value) => {
        const variables = { currentPage: 1, searchKey: value };
        setStateVariable(variables);
        refetch(variables);
    };

    const handleStatusChange = async (selectedId, isEnable) => {
        await dispatch(updatePromoCodeStatus(selectedId, isEnable));
        refetch();
    };

    const handleDelete = async (id, currentPage) => {
        setModalState(false)
        await dispatch(deletePromoCodeData(id))
        const pageResults = getAllPromoCode?.results || [];
        const updatedPage = currentPage > 1 && pageResults.length === 1 ? currentPage - 1 : currentPage;
        setStateVariable({ currentPage: updatedPage, searchKey: '' })
        refetch({ currentPage: updatedPage, searchKey: '' })
    };

    const handleClick = useCallback(() => {
        history.push('/siteadmin/promo-code/add')
    }, [])

    const openPromoDeleteModal = useCallback((id) => {
        setSelectedId(id);
        setModalState(true)
    }, [])



    const thead = () => [
        { data: intl.formatMessage(messages.idLabel) },
        { data: intl.formatMessage(messages.code) },
        { data: intl.formatMessage(messages.titleLabel) },
        { data: intl.formatMessage(messages.tabDiscount) },
        { data: intl.formatMessage(messages.status) },
    ];

    const tbody = () =>
        getAllPromoCode?.results?.map((value, key) => {
            let { title } = getPromoCodeValue(value, intl.locale);
            return {
                id: key,
                data: [
                    { data: value?.id },
                    {
                        data:
                            <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>{value?.code}
                                <TableAction
                                    showEdit={true}
                                    editLink={`/siteadmin/promo-code/edit/${value?.id}`}
                                    showDelete={true}
                                    onClickDelete={() => openPromoDeleteModal(value?.id)}
                                />
                            </div >

                    },
                    { data: title },
                    { data: value?.promoValue + '%' },
                    {
                        data: <div>
                            <select className='commonTableInsideSelect' value={value?.isEnable} onChange={() => handleStatusChange(value?.id, value?.isEnable)}>
                                <option value={true}>{intl.formatMessage(messages.activeLabel)}</option>
                                <option value={false}>{intl.formatMessage(messages.inActiveLabel)}</option>
                            </select>
                        </div>
                    },
                ]
            }
        });


    return (

        <div>
            {modalState &&
                <CustomConfirmModal
                    showModel={modalState}
                    title={intl.formatMessage(messages.deletePromoCode)}
                    bodyText={intl.formatMessage(messages.promoCodeDeleteConfirm)}
                    closeModal={() => setModalState(false)}
                    popupButtonLeftFunction={() => setModalState(false)}
                    popupButtonLeftName={intl.formatMessage(messages.cancel)}
                    popupButtonRightFunction={() => handleDelete(selectedId)}
                    popupButtonRightName={intl.formatMessage(messages.confirmLabel)}
                />
            }
            <CommonTable thead={thead}
                tbody={tbody}
                isLink
                redirectionLabel={intl.formatMessage(messages.addNewLabel)}
                addAction={handleClick}
                title={intl.formatMessage(messages.manageCouponCode)}
                isSearch
                onSearch={(e) => handleSearchChange(e.target.value)}
                isPromoCodeSection
            />

            {getAllPromoCode?.results?.length > 0 &&
                <CustomPagination
                    total={getAllPromoCode?.count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    change={paginationData}
                    paginationLabel={intl.formatMessage(messages.promoCodes)} />
            }
        </div>
    )
}

export default withStyles(cs)(ManagePromoCodeSection);
